module.exports = __webpack_public_path__ + "img/sample-ktp-3.4ef201d7.png";